import { createSelector } from "reselect";

const boothsSelector = (state) => state.booths;
export const getBooths = createSelector([boothsSelector], (state) => state.list);
export const getBoothId = createSelector([boothsSelector], (state) => state.boothId);
export const getSelectedBooth = createSelector([boothsSelector], (state) => state);
